import api from "./index";

export const projectsAPI = {
  // Project CRUD
  getAll: (params) => api.get("/projects", { params }),
  getById: (id) => api.get(`/projects/${id}`),
  create: (data) => api.post("/projects", data),
  update: (id, data) => api.put(`/projects/${id}`, data),
  delete: (id) => api.delete(`/projects/${id}`),

  // Project Details
  getTasks: (id) => api.get(`/projects/${id}/tasks`),
  getStages: (id) => api.get(`/projects/${id}/stages`),
  getBudget: (id) => api.get(`/projects/${id}/budget`),
  getTimeline: (id) => api.get(`/projects/${id}/timeline`),
  getDashboard: (id) => api.get(`/projects/${id}/dashboard`),

  // Project Assignments
  assignUser: (projectId, data) =>
    api.post(`/projects/${projectId}/assign`, data),
  getAssignments: (projectId) => api.get(`/projects/${projectId}/assignments`),
  removeUser: (projectId, userId) =>
    api.delete(`/projects/${projectId}/assignments/${userId}`),
};
